(() => {
  if (window.horusBrowseReady) return;
  window.horusBrowseReady = true;
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-hcs-section]').forEach(section => {
      if (section.dataset.hcsReady) return;
      const track = section.querySelector('.hcs-track');
      const rail = section.querySelector('.hcs-progress');
      if (!track || !rail) return;
      section.dataset.hcsReady = 'true';
      const update = () => {
        const range = track.scrollWidth - track.clientWidth;
        rail.hidden = range <= 1;
        const ratio = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
        rail.style.setProperty('--hcs-thumb', `${ratio * 100}%`);
        rail.style.setProperty('--hcs-offset', `${Math.max(0, Math.min(1, track.scrollLeft / Math.max(1, range))) * (1 - ratio) / ratio * 100}%`);
      };
      track.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
